require('./blocks/digest/digest');
require('./blocks/video-item.less');
require('./blocks/product/product');
require('./blocks/products-slider/products-slider');
require('./blocks/seo-catalog.less');

require('./plugins/jquery.loader/require.js');
require('./blocks/seminars-video/seminars-video');



// WEBPACK FOOTER //
// ./video_presentation.js